import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import thunk from 'redux-thunk';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import ReactGA from 'react-ga';

import rootReducer from './ducks';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig = {
  key: 'ERL',
  storage,
  whitelist: [],
  blacklist: ['instructionFilters'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(persistedReducer, composeEnhancers(applyMiddleware(thunk)));
let currentValue;
store.subscribe(() => {
  const userId = store.getState().user.id;
  if (currentValue !== userId) {
    currentValue = userId;
    ReactGA.set({ userId });
  }
});
export const persistor = persistStore(store);
